import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

    @Output() closeDawer = new EventEmitter<void>();

    constructor() { }

    ngOnInit() {
    }

    close(): void {
        this.closeDawer.emit();
    }

}
